(function() {
  var modal = document.getElementById("myModal");
  var backdrop = document.getElementById("ssCalcBackdrop");
  if (!modal) return;
  document.body.appendChild(backdrop);
  document.body.appendChild(modal);
  var calcProduct = null;
  function openModal() {
    backdrop.classList.add("open");
    modal.classList.add("open");
    document.body.style.overflow = "hidden";
  }
  function closeModal() {
    backdrop.classList.remove("open");
    modal.classList.remove("open");
    document.body.style.overflow = "";
  }
  window.openCalculator = function(params) {
    calcProduct = params;
    document.getElementById("calcHead").textContent = params.name;
    document.getElementById("area").value = "";
    document.getElementById("paint").textContent = "—";
    document.getElementById("unitsforpaint").textContent = "Liters";
    document.getElementById("cost1").textContent = "—";
    document.getElementById("cost2").textContent = "";
    var result = document.getElementById("ssCalcResult");
    if (result) result.style.opacity = "0.4";
    openModal();
    setTimeout(function() {
      document.getElementById("area").focus();
    }, 100);
  };
  var closeBtn = document.getElementById("ssCalcClose");
  if (closeBtn) closeBtn.addEventListener("click", closeModal);
  if (backdrop) backdrop.addEventListener("click", closeModal);
  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape") closeModal();
  });
  var feetsBtn = document.getElementById("feetsBtn");
  var metersBtn = document.getElementById("metersBtn");
  var unitSpan = document.getElementById("unit");
  if (feetsBtn && metersBtn) {
    feetsBtn.addEventListener("click", function() {
      feetsBtn.classList.add("btnStyle");
      metersBtn.classList.remove("btnStyle");
      if (unitSpan) unitSpan.textContent = "feet";
    });
    metersBtn.addEventListener("click", function() {
      metersBtn.classList.add("btnStyle");
      feetsBtn.classList.remove("btnStyle");
      if (unitSpan) unitSpan.textContent = "meters";
    });
  }
  var form = document.getElementById("form");
  if (form) {
    form.addEventListener("submit", function(e) {
      e.preventDefault();
      if (!calcProduct) return;
      var area = parseFloat(document.getElementById("area").value);
      if (!area || area <= 0) return;
      if (unitSpan && unitSpan.textContent === "meters") area *= 10.764;
      var low = calcProduct.lowLimit || 1;
      var high = calcProduct.upLimit || low;
      var bucketSize = calcProduct.sizeOfbigBucket;
      var bucketCost = calcProduct.costOfBigBucket;
      var paintMin = (area / high).toFixed(2);
      var paintMax = (area / low).toFixed(2);
      document.getElementById("paint").textContent = paintMin === paintMax ? paintMin : paintMin + " – " + paintMax;
      document.getElementById("unitsforpaint").textContent = "Liters";
      if (bucketCost > 0 && bucketSize > 0) {
        var bMin = Math.ceil(parseFloat(paintMin) / bucketSize);
        var bMax = Math.ceil(parseFloat(paintMax) / bucketSize);
        var costMin = (bMin * bucketCost).toLocaleString("en-IN");
        var costMax = (bMax * bucketCost).toLocaleString("en-IN");
        document.getElementById("cost1").textContent = "₹" + costMin;
        document.getElementById("cost2").textContent = bMin !== bMax ? " – ₹" + costMax : "";
      } else {
        document.getElementById("cost1").textContent = "Contact us";
        document.getElementById("cost2").textContent = "";
      }
      var result = document.getElementById("ssCalcResult");
      if (result) result.style.opacity = "1";
    });
  }
})();
